import { type FC, useState } from "react";

import { useQuery } from "@apollo/client/react";

import { type MeFragment, MenuOrganizationsDocument } from "@app_schema";

import { MenuItemLink } from "@styled/menu_item_link";
import { Segmented } from "@styled/segmented";

// Internal staff reach every org, sign-ups included, so they get an
// Onboarded / All filter. Everyone else sees their own orgs, unfiltered.
export const MenuProfileOrganizations: FC<{
  me: Pick<MeFragment, "internal">;
}> = ({ me }) => {
  const [filter, setFilter] = useState("onboarded");
  const { data } = useQuery(MenuOrganizationsDocument, {
    variables: { onboarded: me.internal && filter === "onboarded" },
  });

  return (
    <>
      {me.internal && (
        <div className="px-2 pb-2">
          <Segmented
            items={[
              { value: "onboarded", label: "Onboarded" },
              { value: "all", label: "All" },
            ]}
            selectedValue={filter}
            onChange={setFilter}
          />
        </div>
      )}
      {data?.me.organizations.map((organization) => (
        <MenuItemLink
          key={organization.id}
          to={`/dashboard/organizations/${organization.id}`}
        >
          {organization.name}
        </MenuItemLink>
      ))}
    </>
  );
};
